import React, { useEffect, useRef, useState } from 'react';

import { Row, Col } from 'reactstrap'
const StepSection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const currentSection = sectionRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) {
                    setIsVisible(false);
                } else {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.2,
                rootMargin: '0px'
            }
        );

        if (currentSection) {
            observer.observe(currentSection);
        }

        return () => {
            if (currentSection) {
                observer.unobserve(currentSection);
            }
        };
    }, []);

    const steps = [
        {
            id: 1,
            icon: "fa-chart-line",
            title: "Understand business & goals",
            delay: 0.1
        },
        {
            id: 2,
            icon: "fa-draw-polygon",
            title: "Build a clear growth plan",
            delay: 0.2
        },
        {
            id: 3,
            icon: "fa-bullseye",
            title: "Research the right audience",
            delay: 0.3
        },
        {
            id: 4,
            icon: "fa-ad",
            title: "Create ads & landing pages",
            delay: 0.4
        },
        {
            id: 5,
            icon: "fa-chart-bar",
            title: "Campaign channel setup",
            delay: 0.5
        },
        {
            id: 6,
            icon: "fa-rocket",
            title: "Improve performance with data",
            delay: 0.6
        }
    ];
    return (
        <div>

            <div
                className={`process-section ${isVisible ? 'visible' : ''}`}
                ref={sectionRef}
            >

                <div className="">
                    {/* New Title and Subtitle Section */}

                    <div className="process-header">
                        <h1 className="process-main-title">
                            How We Grow Your Business
                        </h1>
                        <h3 className="subtitle ">
                            A clear, structured process designed to attract the right customers, improve performance, and scale your business.
                        </h3>
                    </div>
                    <div className="process-wrapper">
                        <div className="process-steps">
                            {steps.map((step, index) => (
                                <React.Fragment key={step.id}>
                                    <div
                                        className={`step-item ${index % 2 === 0 ? 'odd' : 'even'} ${isVisible ? 'animated' : ''}`}
                                        style={{
                                            transitionDelay: isVisible ? `${step.delay}s` : '0s'
                                        }}
                                    >
                                        <div className="step-circle">
                                            <i className={`fas ${step.icon} step-icon`}></i>
                                        </div>
                                        <div className="step-number-label">
                                            <div className="step-number-badge">Step {step.id}</div>
                                            <div className="step-name">{step.title}</div>
                                        </div>
                                    </div>

                                    {index < steps.length - 1 && (
                                        <div className={`${index % 2 === 0 ? 'odd' : 'even'} step-connector ${isVisible ? 'animated' : ''}`}>
                                            <svg
                                                className={`${index % 2 === 0 ? 'odd' : 'even'} ${isVisible ? 'animated' : ''}`}
                                                viewBox="0 0 100 12"
                                                preserveAspectRatio="none"
                                                style={{
                                                    transitionDelay: isVisible ? `${step.delay + 0.1}s` : '0s'
                                                }}
                                            >
                                                <path
                                                    d="M0,0.5 Q50,5 100,0.5 L100,11.5 Q50,5 0,11.5 Z"
                                                    fill="#ff9800"
                                                    strokeWidth="0.5"
                                                />
                                            </svg>
                                        </div>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>
            </div >
        </div>

    );
};

export default StepSection;